module.exports = __webpack_public_path__ + "img/person_icon.c32b06c.svg";


//////////////////
// WEBPACK FOOTER
// ./assets/searchbox_imgs/person_icon.svg
// module id = ./assets/searchbox_imgs/person_icon.svg
// module chunks = 2 3 4 5 6 7